module.exports = __webpack_public_path__ + "img/cover-minigame-bg.5be2eaf2.jpg";